import React from 'react';
import styled, { css } from 'styled-components';

import { Tag } from 'components';

export type UserStatusTagProps = {
  isDeleted?: boolean;
  isUnverified?: boolean;
  disabled?: boolean;
  inline?: boolean;
  displayActive?: boolean;
  single?: boolean; // only display one tag
};

const getTagProps = ({
  isDeleted,
  isUnverified,
  disabled,
  displayActive = true,
  single = false,
}: UserStatusTagProps) => {
  // User is active if they aren't deleted, unverified or disabled
  // If they are both unverified and disabled then both tags will show
  const tagProps = [];
  if (isDeleted) {
    tagProps.push({ color: 'red', text: 'Deleted' });
    return tagProps;
  }
  if (disabled) {
    tagProps.push({ color: 'default', text: 'Inactive' });
  }
  if (isUnverified) {
    tagProps.push({ color: 'orange', text: 'Unverified' });
  }
  if (tagProps.length === 0 && displayActive) {
    tagProps.push({ color: 'green', text: 'Active' });
  }
  return single ? [tagProps[0]] : tagProps;
};

const UserStatusTag: React.FC<UserStatusTagProps> = props => (
    <StyledStatusTagContainer inline={props.inline}>
      {getTagProps(props).map(({ color, text }, index) => (
        <StyledStatusTag key={index} color={color}>
          {text}
        </StyledStatusTag>
      ))}
    </StyledStatusTagContainer>
  );

export default UserStatusTag;

export const StyledStatusTag = styled(Tag)`
  margin: auto;
`;

export const StyledStatusTagContainer = styled.div<{ inline?: boolean }>`
  ${({ inline }) =>
    inline
      ? css`
          display: flex;
          flex-direction: row;
          & ${StyledStatusTag} {
            margin-right: 8px;
            margin-left: 0;
          }
        `
      : css`
          display: grid;
          grid-template-columns: auto;
          grid-gap: 10px;
          justify-content: center;
        `}
`;
